// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Table-control-Table-module__description";
var _2 = "webpack-concepts-Extraction-Blocks-Table-control-Table-module__labelOuter";
export { _1 as "description", _2 as "labelOuter" }
